<div class="banner">
  <img [src]="url" [alt]="name">
  <h1>{{ title }}</h1>
</div>
